import script from "./Socials.vue?vue&type=script&setup=true&lang=js"
export * from "./Socials.vue?vue&type=script&setup=true&lang=js"

import "./Socials.vue?vue&type=style&index=0&id=259ba4a7&scoped=true&lang=css"

import exportComponent from "/Users/ffavreau/www/canton-dans-le-bouillon/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-259ba4a7"]])

export default __exports__